export const V2_ENGLISH = {
  // leshabank: technical tables on his pages (wrapping, a cell's full value).
  "datox.v2.table.details": "Technical details",
  "datox.v2.table.wrap": "Wrap text",
  "datox.v2.table.value": "Cell value",
  "datox.v2.table.cell": "Row {{row}}, {{column}}",
  "datox.v2.nav": "Navigation",
  "datox.v2.nav.outputs": "All outputs",
  "datox.v2.nav.templates": "Templates",
  "datox.v2.nav.agents": "Agents",
  "datox.v2.nav.preparation": "Preparation and operations",
  "datox.v2.nav.configuration": "Configuration",
  "datox.v2.home.searchLabel": "Search reports and dashboards",
  "datox.v2.home.searchPlaceholder": "Client, code or title",
  "datox.v2.home.project": "Project",
  "datox.v2.home.allProjects": "All projects",
  "datox.v2.home.new": "New",
  "datox.v2.home.type.factsheet": "Factsheet",
  "datox.v2.home.type.report": "Report",
  "datox.v2.home.type.dashboard": "Dashboard",
  "datox.v2.home.review.none": "Not requested",
  "datox.v2.home.review.requested": "Review requested",
  "datox.v2.home.review.approved": "Approved",
  "datox.v2.home.review.rejected": "Changes requested",
  "datox.v2.home.projectWide": "Project-wide",
  "datox.v2.home.notClient": "Not client-specific",
  "datox.v2.home.attention": "Needs attention",
  "datox.v2.home.status": "{{outputs}} · {{clients}}",
  "datox.v2.home.outputs.one": "{{count}} output",
  "datox.v2.home.outputs.other": "{{count}} outputs",
  "datox.v2.home.clients.one": "{{count}} client",
  "datox.v2.home.clients.other": "{{count}} clients",
  "datox.v2.home.loading": "Loading reports and dashboards…",
  "datox.v2.home.error": "Reports and dashboards could not be loaded.",
  "datox.v2.home.retry": "Try again",
  "datox.v2.home.empty": "No reports or dashboards yet.",
  "datox.v2.home.noMatch": "Nothing matches this search.",
  "datox.v2.home.filters": "Filters",
  "datox.v2.home.clearFilters": "Clear all",
  "datox.v2.home.filter.client": "Client",
  "datox.v2.home.filter.type": "Type",
  "datox.v2.home.filter.review": "Review",
  "datox.v2.home.filter.access": "Access",
  "datox.v2.home.filter.scope": "Project and period",
  "datox.v2.home.period": "Period",
  "datox.v2.home.allPeriods": "All periods",
  "datox.v2.home.access.published": "Published",
  "datox.v2.home.access.draft": "Draft",
  "datox.v2.home.asOf": "Data as of {{date}}",
  "datox.v2.home.outputsCount.one": "{{count}} report or dashboard",
  "datox.v2.home.outputsCount.other": "{{count}} reports and dashboards",
  "datox.v2.home.updatedToday": "Updated today",
  "datox.v2.home.fresh": "Updated in the last 7 days",
  "datox.v2.home.send": "Send",
  "datox.v2.home.moreFilters": "More filters",
  "datox.v2.home.clearClient": "Show all clients",
  "datox.v2.home.sendSoon": "Sending to the client is not connected yet",
  "datox.v2.nav.reports": "Reports",
  "datox.v2.nav.toolsShow": "Show workspace tools",
  "datox.v2.nav.toolsHide": "Hide workspace tools",
  "datox.v2.nav.reporting": "Reporting",
  "datox.v2.nav.outputsGroup": "Outputs and review",
  "datox.v2.nav.reportFiles": "Report files",
  "datox.v2.nav.collapse": "Collapse sidebar",
  "datox.v2.nav.expand": "Expand sidebar",
  "datox.v2.nav.operations": "Operations",
  "datox.v2.nav.recent": "Recent",
  "datox.v2.nav.companies": "Companies",
  "datox.v2.nav.company.home": "{{company}}, Reports",
  "datox.v2.nav.company.switch": "{{company}}, switch company",
  "datox.v2.reports.searchLabel": "Search reports and clients",
  "datox.v2.reports.searchPlaceholder": "Report, client or code",
  "datox.v2.reports.type.factsheet": "Factsheet",
  "datox.v2.reports.type.custom": "Custom report",
  "datox.v2.reports.type.history": "Earlier report",
  "datox.v2.reports.filter.status": "Status",
  "datox.v2.reports.count.one": "{{count}} report",
  "datox.v2.reports.count.other": "{{count}} reports",
  "datox.v2.reports.updated": "Updated {{when}}",
  "datox.v2.reports.loading": "Loading reports…",
  "datox.v2.reports.error": "Reports could not be loaded.",
  "datox.v2.reports.empty": "No reports yet.",
  "datox.v2.reports.sendTitle": "Send {{name}}",
  "datox.v2.reports.close": "Close",
  "datox.v2.editor.crumbs": "Report location",
  "datox.v2.editor.clients": "Clients",
  "datox.v2.editor.clientPrevious": "Previous client",
  "datox.v2.editor.clientNext": "Next client",
  "datox.v2.editor.state.suggests": "Workflow suggests: {{reason}}",
  "datox.v2.editor.clientSearch": "Find a client",
  "datox.v2.editor.clientNone": "No client matches",
  "datox.v2.editor.tools": "Report tools",
  "datox.v2.editor.view": "View",
  "datox.v2.editor.exportPdf": "Export PDF",
  "datox.v2.editor.latest": "Back to latest",
  "datox.v2.editor.noCanvas": "This client has no canvas yet.",
  "datox.v2.editor.blocked.unsaved": "Wait until the canvas changes are saved, then ask the agent.",
  "datox.v2.editor.blocked.running": "A workflow run is updating this report. Ask again when it finishes.",
  "datox.v2.editor.blocked.runtime": "Agent not connected. The agent runtime isn't configured for this app yet.",
  "datox.v2.editor.retrySave": "Retry save",
  "datox.v2.editor.needsData.files": "No data yet. Upload or select the input files, then run the workflow.",
  "datox.v2.editor.needsData.period": "No data yet. Choose a reporting period, then add the input files.",
  "datox.v2.editor.needsData.targets": "No data yet. Add a named portfolio target, then run the workflow.",
  "datox.v2.editor.needsData.categories": "No data yet. Create a category, then run the workflow.",
  "datox.v2.editor.needsData.fields": "No data yet. Give each category a name and at least one named field, then run the workflow.",
  "datox.v2.editor.needsData.run": "No data yet. The input files are in; run the workflow to fill the sheet.",
  "datox.v2.editor.needsData.add": "Add data",
  "datox.v2.editor.needsData.hide": "Hide for this session",
  "datox.v2.editor.selection.toolbar": "Widget actions",
  "datox.v2.editor.selection.ask": "Ask agent",
  "datox.v2.editor.selection.askHint": "Open the assistant with this widget as its context",
  "datox.v2.editor.selection.ideas": "Suggestions for this widget",
  "datox.v2.editor.selection.ideaHint": "puts it in the chat, nothing is sent",
  "datox.v2.editor.selection.edit": "Edit widget",
  "datox.v2.editor.selection.more": "More widget actions",
  "datox.v2.editor.agent.title.factsheet": "Ask about {{name}}'s factsheet",
  "datox.v2.editor.agent.title.report": "Ask about {{name}}'s report",
  "datox.v2.editor.agent.title.named": "Ask about {{name}}",
  "datox.v2.editor.agent.title.thisFactsheet": "Ask about this factsheet",
  "datox.v2.editor.agent.title.thisReport": "Ask about this report",
  "datox.v2.editor.agent.intro": "Ask about a number, or ask it to change the page.",
  "datox.v2.editor.agent.starters": "Suggested requests",
  "datox.v2.editor.agent.starterHint": "Adds this request to the message box. Nothing is sent until you press Send.",
  "datox.v2.editor.agent.starter.changes": "Explain the key changes this month",
  "datox.v2.editor.agent.starter.gaps": "Check for missing or N/A values",
  "datox.v2.editor.agent.starter.fit": "Make this page fit one A4 sheet",
  "datox.v2.editor.agent.starter.summary": "Summarise for the client in 3 sentences",
  "datox.v2.editor.agent.starter.widgetExplain": "Explain what this widget shows",
  "datox.v2.editor.agent.starter.widgetGaps": "Check this widget for missing or N/A values",
  "datox.v2.editor.agent.starter.widgetClearer": "Make this widget easier to read",
  "datox.v2.editor.agent.starter.widgetNote": "Write a one-line note on it for the client",
  "datox.v2.editor.agent.history": "Open an earlier chat",
  "datox.v2.editor.agent.keys": "Enter sends, Shift+Enter starts a new line",
  "datox.v2.editor.agent.title.widget": "Ask about {{name}}",
  "datox.v2.editor.agent.starter.addFiles": "Help me add the input files",
  "datox.v2.editor.agent.starter.templateNeeds": "What does this template need?",
  "datox.v2.editor.agent.starter.howBuilt": "Explain how this report is built",
  "datox.v2.editor.asOf": "Data as of {{date}}",
  "datox.v2.editor.period": "Period {{name}}",
  "datox.v2.editor.asOfHint": "The date this report's data was prepared for",
  "datox.v2.editor.uploaded": "Uploaded {{date}}",
  "datox.v2.editor.uploadedHint": "The data's end date isn't available yet",
  "datox.v2.editor.review": "Review: {{state}}",
  "datox.v2.editor.reviewOpen": "Review status. Opens Request review",
  "datox.v2.editor.preview": "Preview",
  // §75: the sheet's style in Brand.
  "datox.v2.sheet.style": "Style",
  "datox.v2.sheet.style.swiss": "Swiss",
  "datox.v2.sheet.style.cards": "Cards",
  "datox.v2.sheet.style.bold": "Bold",
  "datox.v2.sheet.style.lesha": "Lesha",
  // §74j: the dot on Workflow when the last run failed.
  "datox.v2.editor.view.workflowFailed": "The last run failed",
  "datox.v2.editor.view.workflowFailedName": "Workflow, the last run failed",
  "datox.v2.editor.newReport": "New report",
  "datox.v2.editor.requestReview": "Request review",
  "datox.v2.editor.loading": "Loading the report",
  "datox.v2.editor.selection.count.one": "{{count}} widget",
  "datox.v2.editor.selection.count.other": "{{count}} widgets",
  "datox.v2.editor.selection.duplicateAll": "Duplicate widgets",
  "datox.v2.editor.selection.deleteAll": "Delete widgets",
  // editor (UX research)
  "datox.v2.editor.deleted.one": "{{name}} deleted",
  "datox.v2.editor.deleted.many.one": "{{count}} widget deleted",
  "datox.v2.editor.deleted.many.other": "{{count}} widgets deleted",
  "datox.v2.editor.deleted.page": "Page {{name}} deleted",
  "datox.v2.editor.deleted.pageFallback": "Page",
  "datox.v2.editor.deleted.close": "Dismiss",
  "datox.v2.editor.tidied": "Page tidied",
  "datox.v2.editor.dropOutside.one": "{{count}} widget doesn't fit on this page",
  "datox.v2.editor.dropOutside.other": "{{count}} widgets don't fit on this page",
  "datox.v2.editor.agentSaved": "Agent saved Rev {{number}}",
  "datox.v2.editor.viewPrevious": "View previous",
  "datox.v2.editor.dataTo": "Data to {{date}}",
  "datox.v2.editor.dataToHint": "The last day the figures in this report cover",
  "datox.v2.editor.reportScope.one": "{{name}} · a template for {{count}} client report",
  "datox.v2.editor.reportScope.other": "{{name}} · a template for {{count}} client reports",
  "datox.v2.editor.clientCrumb": "Client: {{name}}. Switch client",
  "datox.v2.editor.clientPreviousTip": "Previous client · {{index}} of {{total}}",
  "datox.v2.editor.clientNextTip": "Next client · {{index}} of {{total}}",
  "datox.v2.editor.periodDay": "Period · {{date}}",
  "datox.v2.editor.period.title": "Periods",
  "datox.v2.editor.period.button": "Period: {{period}}",
  "datox.v2.editor.period.tip": "Open this client in another period",
  "datox.v2.editor.period.previous": "Previous period",
  "datox.v2.editor.period.locked": "Save your changes first",
  "datox.v2.editor.reviewOpenSend": "Review status. Opens Send",
  "datox.v2.editor.deleteReport.one": "Delete {{name}} ({{count}} client)…",
  "datox.v2.editor.deleteReport.other": "Delete {{name}} ({{count}} clients)…",
  "datox.v2.editor.send": "Send",
  "datox.v2.editor.send.title": "Send {{client}}'s report",
  "datox.v2.editor.send.pdfTitle": "Download PDF",
  "datox.v2.editor.send.pdfText": "Save {{client}}'s report as a PDF to email it to the client.",
  "datox.v2.editor.send.pdf": "Download PDF",
  "datox.v2.editor.send.reviewTitle": "Or ask a colleague to review it first",
  "datox.v2.editor.agent.many.one": "{{count}} widget selected. Select one widget to ask about it.",
  "datox.v2.editor.agent.many.other": "{{count}} widgets selected. Select one widget to ask about it.",
  "datox.v2.editor.agent.clearContext": "Clear the selection",
  "datox.v2.editor.staleLink": "This link is out of date.",
  "datox.v2.editor.backToReports": "Back to reports",
  "datox.v2.editor.openClient": "Open {{name}}",
  "datox.v2.title.loading": "Loading… — Lesha Bank",
  "datox.v2.workflow.title": "Workflow",
  "datox.v2.workflow.scope.one": "{{report}} · 1 report",
  "datox.v2.workflow.scope.other": "{{report}} · feeds {{count}} client reports",
  "datox.v2.workflow.history": "Run history",
  "datox.v2.workflow.steps": "Workflow steps",
  "datox.v2.workflow.loading": "Loading the workflow…",
  "datox.v2.workflow.status.done": "Done",
  "datox.v2.workflow.status.todo": "To do",
  "datox.v2.workflow.status.attention": "Needs you",
  "datox.v2.workflow.status.running": "Running",
  "datox.v2.workflow.status.waiting": "Waits for an earlier step",
  "datox.v2.workflow.step.files": "Data files",
  "datox.v2.workflow.step.update": "Update the report",
  "datox.v2.workflow.step.review": "Review",
  "datox.v2.workflow.why.files": "Upload the new files when this month's exports arrive.",
  "datox.v2.workflow.why.update.one": "Reads the current files and refreshes this report.",
  "datox.v2.workflow.why.update.other": "Reads the current files and refreshes all {{count}} client reports.",
  "datox.v2.workflow.why.review": "A colleague checks the report before you send it.",
  "datox.v2.workflow.card.upload": "Upload this month's exports.",
  "datox.v2.workflow.card.uploading": "Uploading files…",
  "datox.v2.workflow.card.running": "Updating…",
  "datox.v2.workflow.card.failed": "The last update failed.",
  "datox.v2.workflow.card.noClient": "The last update has no data for {{client}}.",
  "datox.v2.workflow.card.requestReview": "Data is up to date. Ask a colleague to review.",
  "datox.v2.workflow.card.lookOver": "The report is filled · {{when}}. Look it over before you send it.",
  "datox.v2.workflow.card.waitingReview": "Waiting for review.",
  "datox.v2.workflow.card.waitingReviewFrom": "Waiting for review from {{names}}.",
  "datox.v2.workflow.card.changes": "Changes requested.",
  "datox.v2.workflow.card.approved": "Approved. Ready to send.",
  "datox.v2.workflow.card.action.upload": "Upload files",
  "datox.v2.workflow.card.action.setup": "Open setup",
  "datox.v2.workflow.card.action.run": "Run",
  "datox.v2.workflow.card.action.retry": "Try again",
  "datox.v2.workflow.card.action.settings": "Check report settings",
  "datox.v2.workflow.card.action.requestReview": "Request review",
  "datox.v2.workflow.card.action.openReport": "Open report",
  "datox.v2.workflow.card.action.openReview": "Open review",
  "datox.v2.workflow.card.action.share": "Send",
  "datox.v2.workflow.files.uploading": "Uploading files…",
  "datox.v2.workflow.files.error": "Files could not be loaded",
  "datox.v2.workflow.files.none": "No files yet",
  "datox.v2.workflow.files.notReady.one": "{{count}} file is being processed",
  "datox.v2.workflow.files.notReady.other": "{{count}} files are being processed",
  "datox.v2.workflow.files.done.one": "1 file · uploaded {{date}}",
  "datox.v2.workflow.files.done.other": "{{count}} files · uploaded {{date}}",
  "datox.v2.workflow.files.file": "File",
  "datox.v2.workflow.files.uploaded": "Uploaded",
  "datox.v2.workflow.files.dropTitle": "Add the source files for this period",
  "datox.v2.workflow.files.dropHint": "For example the prices export and the positions file. Drop them here, upload them, or pull them from an integration.",
  "datox.v2.workflow.files.contains": "What it contains",
  "datox.v2.workflow.files.preview": "Preview",
  "datox.v2.workflow.files.notReadyRow": "Not ready yet",
  "datox.v2.workflow.review.waiting": "After the report has data",
  "datox.v2.workflow.review.approved": "Approved",
  "datox.v2.workflow.review.rejected": "Changes requested",
  "datox.v2.workflow.review.requested": "Requested. Waiting for the reviewers.",
  "datox.v2.workflow.review.none": "Not requested yet",
  "datox.v2.workflow.action.upload": "Upload files",
  "datox.v2.workflow.action.run": "Run",
  "datox.v2.workflow.action.requestReview": "Request review",
  "datox.v2.workflow.action.integration": "From integration",
  "datox.v2.workflow.pane.openEditor": "Open in Editor",
  "datox.v2.workflow.runStatus.completed": "Completed",
  "datox.v2.workflow.runStatus.failed": "Failed",
  "datox.v2.workflow.runStatus.cancelled": "Cancelled",
  "datox.v2.workflow.runStatus.interrupted": "Interrupted",
  "datox.v2.workflow.runStatus.running": "Running",
  "datox.v2.workflow.runStatus.waiting": "Waiting for files",
  "datox.v2.workflow.runStatus.other": "Started",
  "datox.v2.workflow.run.addFiles": "Add files to run",
  "datox.v2.workflow.run.blocked.loading": "Still checking the update. Try again in a moment.",
  "datox.v2.workflow.run.blocked.error": "Couldn't check the update. Refresh the page and try again.",
  "datox.v2.workflow.run.blocked.permission": "You don't have permission to update this report.",
  "datox.v2.workflow.run.blocked.active": "An update is already running.",
  "datox.v2.workflow.run.againCurrent": "Run again with the current files",
  "datox.v2.workflow.run.current": "Run with the current files",
  "datox.v2.workflow.run.currentHint": "Reads this period's files and refreshes every client report in the workflow.",
  "datox.v2.workflow.run.automation": "Set up automation",
  "datox.v2.workflow.run.automationHint": "Run this workflow on a schedule or when new files arrive.",
  "datox.v2.workflow.technical": "Technical details",
  "datox.v2.workflow.technical.close": "Close technical details",
  "datox.v2.tech.open": "Open technical details",
  "datox.v2.tech.tabs": "Technical details sections",
  "datox.v2.tech.tab.files": "Files",
  "datox.v2.tech.tab.tables": "Tables",
  "datox.v2.tech.tab.extractions": "Extractions",
  "datox.v2.tech.tab.calculations": "Calculations",
  "datox.v2.tech.tab.output": "Output",
  "datox.v2.tech.tab.approval": "Approval",
  "datox.v2.tech.tab.data": "Data",
  "datox.v2.tech.data.list": "Files and tables",
  "datox.v2.tech.data.other": "Not read from a file yet",
  "datox.v2.tech.data.empty": "No files or tables yet. An analyst adds files with Edit pipeline.",
  "datox.v2.tech.data.emptyEditing": "No files yet. Upload one, or drop it here.",
  "datox.v2.tech.data.pick": "Pick a file or a table.",
  "datox.v2.tech.data.views": "Table view",
  "datox.v2.tech.data.rows": "Rows",
  "datox.v2.tech.data.fields": "Fields",
  "datox.v2.tech.data.fieldCount.one": "1 field",
  "datox.v2.tech.data.fieldCount.other": "{{count}} fields",
  "datox.v2.tech.data.from": "from {{files}}",
  "datox.v2.tech.data.history.one": "History · 1 read",
  "datox.v2.tech.data.history.other": "History · {{count}} reads",
  "datox.v2.tech.data.historyEmpty": "Not read yet.",
  "datox.v2.tech.output.other": "Not on any page",
  "datox.v2.tech.tip.files.one": "Files · 1 file in this period",
  "datox.v2.tech.tip.files.other": "Files · {{count}} files in this period",
  "datox.v2.tech.tip.tables.one": "Tables · 1 table read from the files",
  "datox.v2.tech.tip.tables.other": "Tables · {{count}} tables read from the files",
  "datox.v2.tech.tip.extractions.done": "Extraction · done",
  "datox.v2.tech.tip.extractions.failed": "Extraction · failed",
  "datox.v2.tech.tip.extractions.running": "Extraction · running",
  "datox.v2.tech.tip.extractions.none": "Extraction · not run yet",
  "datox.v2.tech.tip.calculations.done": "Calculation · done",
  "datox.v2.tech.tip.calculations.failed": "Calculation · failed",
  "datox.v2.tech.tip.calculations.running": "Calculation · running",
  "datox.v2.tech.tip.calculations.none": "Calculation · not run yet",
  "datox.v2.tech.tip.output.one": "Output · 1 table for this client",
  "datox.v2.tech.tip.output.other": "Output · {{count}} tables for this client",
  "datox.v2.tech.tip.approval.one": "Approval · 1 review pending",
  "datox.v2.tech.tip.approval.other": "Approval · {{count}} reviews pending",
  "datox.v2.tech.tip.loading": "Loading…",
  "datox.v2.tech.loading": "Loading the technical details…",
  "datox.v2.tech.tone.red": "Something failed",
  "datox.v2.tech.tone.amber": "Something is in progress or needs a look",
  "datox.v2.tech.readOnly": "Read only",
  "datox.v2.tech.readOnlyHint": "Nothing here can be changed until an analyst turns on Edit pipeline.",
  "datox.v2.tech.expand": "Expand",
  "datox.v2.tech.restore": "Restore size",
  "datox.v2.tech.resize": "Resize technical details",
  // 47: the sheet's scope lines, plurals, search and export wording, no raw ids.
  "datox.v2.tech.tip.outputAll.one": "Output · 1 table",
  "datox.v2.tech.tip.outputAll.other": "Output · {{count}} tables",
  "datox.v2.tech.scope.shared.one": "Shared by every report in this period.",
  "datox.v2.tech.scope.shared.other": "Shared by all {{count}} client reports in this period, not only this client's.",
  "datox.v2.tech.calc.from": "From {{tables}}",
  "datox.v2.tech.calc.title": "Calculation",
  "datox.v2.tech.calc.completed": "Completed {{when}}",
  "datox.v2.tech.calc.failed": "Failed {{when}}",
  "datox.v2.tech.calc.running": "Running since {{when}}",
  "datox.v2.tech.calc.other": "{{status}} · {{when}}",
  "datox.v2.tech.calc.tables.one": "1 report table",
  "datox.v2.tech.calc.tables.other": "{{count}} report tables",
  "datox.v2.tech.calc.allClients": "All clients",
  "datox.v2.tech.calc.checksPassed": "{{subject}}: checks passed",
  "datox.v2.tech.calc.checksFailed.one": "{{subject}}: 1 check failed",
  "datox.v2.tech.calc.checksFailed.other": "{{subject}}: {{count}} checks failed",
  "datox.v2.tech.calc.checks.one": "{{subject}}: 1 check",
  "datox.v2.tech.calc.checks.other": "{{subject}}: {{count}} checks",
  "datox.v2.tech.calc.tasks.completed.one": "Completed · 1 task",
  "datox.v2.tech.calc.tasks.completed.other": "Completed · {{count}} tasks",
  "datox.v2.tech.calc.tasks.running.one": "In progress · 1 task",
  "datox.v2.tech.calc.tasks.running.other": "In progress · {{count}} tasks",
  "datox.v2.tech.calc.tasks.failed.one": "Failed · 1 task",
  "datox.v2.tech.calc.tasks.failed.other": "Failed · {{count}} tasks",
  "datox.v2.tech.calc.tasks.other.one": "{{status}} · 1 task",
  "datox.v2.tech.calc.tasks.other.other": "{{status}} · {{count}} tasks",
  // §74: a report run as its tasks (the setup screen's step 3, Workflow's Update step).
  "datox.v2.run.label": "The update's progress",
  "datox.v2.run.running": "Filling the report",
  "datox.v2.run.failed": "Failed · {{when}}",
  "datox.v2.run.took": "took {{span}}",
  "datox.v2.run.done": "Done",
  "datox.v2.run.doneIn": "Done · {{span}}",
  "datox.v2.run.stopped": "Stopped · {{when}}",
  "datox.v2.run.minutes.one": "1 min",
  "datox.v2.run.minutes.other": "{{count}} min",
  "datox.v2.run.minutes.under": "under a minute",
  "datox.v2.run.files.one": "Read 1 file",
  "datox.v2.run.files.other": "Read {{count}} files",
  "datox.v2.run.tables.todo": "Find the tables",
  "datox.v2.run.tables.current": "Finding the tables…",
  "datox.v2.run.tables.done.one": "Found 1 table",
  "datox.v2.run.tables.done.other": "Found {{count}} tables",
  "datox.v2.run.tables.doneAny": "Found the tables",
  "datox.v2.run.tables.found.one": "1 found so far",
  "datox.v2.run.tables.found.other": "{{count}} found so far",
  "datox.v2.run.calculate.todo": "Calculate",
  "datox.v2.run.calculate.current": "Calculating…",
  "datox.v2.run.calculate.done": "Calculated",
  "datox.v2.run.fill.todo.one": "Fill 1 page",
  "datox.v2.run.fill.todo.other": "Fill {{count}} pages",
  "datox.v2.run.fill.todoAny": "Fill the pages",
  "datox.v2.run.fill.current.one": "Filling 1 page…",
  "datox.v2.run.fill.current.other": "Filling {{count}} pages…",
  "datox.v2.run.fill.currentAny": "Filling the pages…",
  "datox.v2.run.fill.done.one": "Filled 1 page",
  "datox.v2.run.fill.done.other": "Filled {{count}} pages",
  "datox.v2.run.fill.doneAny": "Filled the pages",
  "datox.v2.run.notReached": "not reached",
  "datox.v2.run.status.done": "Done",
  "datox.v2.run.status.current": "In progress",
  "datox.v2.run.status.todo": "Next",
  "datox.v2.run.status.failed": "Failed",
  "datox.v2.run.status.notReached": "Not reached",
  "datox.v2.run.issue.noTables": "No tables were read from the files",
  "datox.v2.run.issue.lostAccess": "The assistant lost access during the run",
  "datox.v2.run.issue.noOutputs": "No report tables were made",
  "datox.v2.run.issue.noVerified": "No checked numbers were saved",
  "datox.v2.run.issue.placeholders": "The report still has placeholder values",
  "datox.v2.run.issue.noFactsheet": "No factsheet was saved",
  "datox.v2.run.issue.noPages": "The report pages weren't filled",
  "datox.v2.run.issue.ended": "The update stopped unexpectedly",
  "datox.v2.run.hint.noTables": "Check that it is this period's export.",
  "datox.v2.run.hint.lostAccess": "Nothing is wrong with your files.",
  "datox.v2.run.details": "Show details",
  "datox.v2.run.id": "Run {{id}}",
  "datox.v2.run.copy": "Copy",
  "datox.v2.run.copied": "Copied",
  // §74, §74c: a new report's setup screen (its Preview while it has nothing to show), one thing at a time.
  "datox.v2.setup.loading": "Loading this report's files",
  "datox.v2.setup.title.add": "Add this period's files",
  "datox.v2.setup.title.ready": "Ready to fill the report",
  "datox.v2.setup.title.setup": "Set up the report's tables first",
  "datox.v2.setup.title.setup.period": "Choose the report's period first",
  "datox.v2.setup.title.setup.targets": "Name the report's client first",
  "datox.v2.setup.title.running": "Filling the report…",
  "datox.v2.setup.title.failed": "The report couldn't be filled",
  "datox.v2.setup.title.readOnly": "No data yet",
  "datox.v2.setup.title.empty": "The run finished, but this report got no data",
  "datox.v2.setup.empty.default": "The files may not include this client.",
  "datox.v2.setup.files.failed": "Couldn't read this file",
  "datox.v2.setup.blocked.failedFile": "Remove the file that couldn't be read",
  "datox.v2.setup.blocked.processing": "The files are still being read",
  "datox.v2.setup.sub.one": "The assistant reads your {{exports}} and fills 1 page: {{names}}.",
  "datox.v2.setup.sub.other": "The assistant reads your {{exports}} and fills {{count}} pages: {{names}}.",
  "datox.v2.setup.subAdd.one": "The assistant reads your exports and fills 1 page: {{names}}.",
  "datox.v2.setup.subAdd.other": "The assistant reads your exports and fills {{count}} pages: {{names}}.",
  "datox.v2.setup.exports.one": "export",
  "datox.v2.setup.exports.other": "{{count}} exports",
  "datox.v2.setup.sub.any": "The assistant reads your exports and fills the report.",
  "datox.v2.setup.sub.setup": "A blank report needs its tables before the assistant can fill it.",
  "datox.v2.setup.sub.setup.period": "The report needs its period before the assistant can fill it.",
  "datox.v2.setup.sub.setup.targets": "Each client of the report needs a name before the assistant can fill it.",
  "datox.v2.setup.ask.files": "Ask your analyst to add this period's files.",
  "datox.v2.setup.ask.setup": "Ask your analyst to set up its tables.",
  "datox.v2.setup.ask.setup.period": "Ask your analyst to choose its period.",
  "datox.v2.setup.ask.setup.targets": "Ask your analyst to name its client.",
  "datox.v2.setup.drop": "Drop the exports here, or",
  "datox.v2.setup.files": "This period's files",
  "datox.v2.setup.filesCount": "Files · {{count}}",
  "datox.v2.setup.files.add": "Add files",
  "datox.v2.setup.files.processing": "getting ready…",
  "datox.v2.setup.fill": "Fill the report",
  "datox.v2.setup.for.client": "For {{name}}",
  "datox.v2.setup.for.every": "For every client in the files",
  "datox.v2.setup.client.chooseOne": "Choose one client",
  "datox.v2.setup.client.choose": "Choose client",
  "datox.v2.setup.client.change": "Change",
  "datox.v2.setup.client.saving": "Saving…",
  "datox.v2.setup.client.error": "The client couldn't be saved. Try again.",
  "datox.v2.setup.next": "Next: check the filled report, then send it.",
  "datox.v2.setup.side.activity": "What the assistant is doing",
  // §74: the New dialog's client.
  "datox.v2.create.client": "Client",
  "datox.v2.create.noClient": "No client",
  "datox.v2.create.clientHint": "Without one, a factsheet makes a report for each client in the files.",
  // §74: Remove an uploaded file (Workflow's Files and the setup screen).
  "datox.v2.files.remove": "Remove",
  "datox.v2.files.removeFile": "Remove {{name}}",
  "datox.v2.files.removeAsk": "Remove from this period?",
  "datox.v2.files.removeReads.one": "1 report reads it.",
  "datox.v2.files.removeReads.other": "{{count}} reports read it.",
  "datox.v2.files.removeConfirm": "Remove",
  "datox.v2.files.removeError": "The file couldn't be removed. Try again.",
  "datox.v2.tech.calc.assumptions": "Assumptions",
  "datox.v2.tech.scope.sharedShort.one": "This period's only report",
  "datox.v2.tech.scope.sharedShort.other": "Shared by all {{count}} reports",
  "datox.v2.tech.approval.none": "Not requested",
  "datox.v2.tech.approval.noneLine": "No one has been asked to review this report yet.",
  "datox.v2.tech.approval.request": "Request review",
  "datox.v2.tech.approval.error": "The review status couldn't be loaded.",
  "datox.v2.tech.approval.review": "In review · {{approved}} of {{total}} approved",
  "datox.v2.tech.approval.approved": "Approved · {{when}}",
  "datox.v2.tech.approval.rejected": "Rejected · {{when}}",
  "datox.v2.tech.approval.changes": "Changes requested · {{when}}",
  "datox.v2.tech.approval.requested": "Requested {{when}}",
  "datox.v2.tech.approval.reviewers": "Reviewers",
  "datox.v2.tech.approval.decided": "{{kind}} · {{when}}",
  "datox.v2.tech.approval.kind.approved": "Approved",
  "datox.v2.tech.approval.kind.rejected": "Rejected",
  "datox.v2.tech.approval.kind.changes": "Changes requested",
  "datox.v2.tech.approval.kind.viewed": "Viewed",
  "datox.v2.tech.approval.kind.pending": "Pending",
  "datox.v2.tech.drop.one.one": "Upload {{name}}? It's used by this report.",
  "datox.v2.tech.drop.one.other": "Upload {{name}}? It's used by all {{count}} client reports.",
  "datox.v2.tech.drop.many.one": "Upload {{files}} files? They're used by this report.",
  "datox.v2.tech.drop.many.other": "Upload {{files}} files? They're used by all {{count}} client reports.",
  "datox.v2.tech.dialog.scope.one": "Changes here affect this report.",
  "datox.v2.tech.dialog.scope.other": "Changes here affect all {{count}} client reports.",
  "datox.v2.tech.files.period": "Period {{period}}",
  "datox.v2.tech.files.meta": "{{size}} · uploaded {{date}}",
  "datox.v2.tech.files.emptyReadOnly": "No files yet. An analyst adds them with Edit pipeline.",
  "datox.v2.tech.files.parts.one": "1 sheet",
  "datox.v2.tech.files.parts.other": "{{count}} sheets",
  "datox.v2.tech.rows.one": "1 row",
  "datox.v2.tech.rows.other": "{{n}} rows",
  "datox.v2.tech.columns.one": "1 column",
  "datox.v2.tech.columns.other": "{{n}} columns",
  "datox.v2.tech.records.one": "1 record",
  "datox.v2.tech.records.other": "{{n}} records",
  "datox.v2.tech.tables.one": "1 table",
  "datox.v2.tech.tables.other": "{{n}} tables",
  "datox.v2.tech.outputTables.one": "1 output table",
  "datox.v2.tech.outputTables.other": "{{n}} output tables",
  "datox.v2.tech.records.noMatch": "Nothing matches \"{{query}}\".",
  "datox.v2.tech.empty.extractions": "Nothing read yet. It runs after files are added: Workflow, then Run.",
  "datox.v2.tech.empty.calculations": "Nothing calculated yet. It runs after the files are read: Workflow, then Run.",
  "datox.v2.tech.ofTotal": "{{shown}} of {{total}}",
  "datox.v2.tech.client.toggle": "Whose rows",
  "datox.v2.tech.client.this": "This client",
  "datox.v2.tech.client.all": "All clients",
  "datox.v2.tech.client.allCount.one": "All clients (1)",
  "datox.v2.tech.client.allCount.other": "All clients ({{count}})",
  "datox.v2.tech.search.rows": "Find in rows",
  "datox.v2.tech.search.count.one": "{{shown}} of 1 row",
  "datox.v2.tech.search.count.other": "{{shown}} of {{n}} rows",
  "datox.v2.tech.search.none": "No rows match \"{{query}}\".",
  "datox.v2.tech.export.csvRows.one": "Download CSV",
  "datox.v2.tech.export.csvRows.other": "Download CSV",
  "datox.v2.tech.export.copyRows.one": "Copy 1 matching row",
  "datox.v2.tech.export.copyRows.other": "Copy {{n}} matching rows",
  "datox.v2.tech.output.from": "calculated {{date}}",
  "datox.v2.tech.output.noRows": "No rows",
  "datox.v2.tech.approval.noReviewers": "No one has been asked to review this report yet. Request a review from Send.",
  "datox.v2.tech.empty.output": "Nothing calculated for this client yet. It runs after the files are read: Workflow, then Run.",
  "datox.v2.tech.tables.emptyReadOnly": "No tables yet. They're read from the files when the report updates.",
  "datox.v2.tech.copyID": "Copy ID",
  "datox.v2.tech.copiedID": "ID copied",
  "datox.v2.workflow.preview.meta": "{{type}} · {{size}} · uploaded {{date}}",
  "datox.v2.workflow.preview.type.excel": "Excel",
  "datox.v2.workflow.preview.type.csv": "CSV",
  "datox.v2.workflow.preview.type.pdf": "PDF",
  "datox.v2.workflow.preview.type.json": "JSON",
  "datox.v2.workflow.preview.type.presentation": "PowerPoint",
  "datox.v2.workflow.preview.type.image": "Image",
  "datox.v2.workflow.preview.type.file": "File",
  "datox.v2.workflow.preview.size.b": "{{size}} B",
  "datox.v2.workflow.preview.size.kb": "{{size}} KB",
  "datox.v2.workflow.preview.size.mb": "{{size}} MB",
  "datox.v2.workflow.preview.download": "Download",
  "datox.v2.workflow.preview.close": "Close preview",
  "datox.v2.workflow.preview.sheets": "Sheets",
  "datox.v2.workflow.preview.loading": "Loading preview…",
  "datox.v2.workflow.preview.error": "This file can't be previewed. Download it to open it.",
  "datox.v2.workflow.preview.empty": "This sheet is empty.",
  "datox.v2.workflow.preview.limit.one": "Showing the first row",
  "datox.v2.workflow.preview.limit.other": "Showing the first {{count}} rows",
  "datox.v2.workflow.processing.last.completed": "Last run completed {{when}}",
  "datox.v2.workflow.processing.last.failed": "Last run failed {{when}}",
  "datox.v2.workflow.processing.last.cancelled": "Last run cancelled {{when}}",
  "datox.v2.workflow.processing.last.interrupted": "Last run stopped {{when}}",
  "datox.v2.workflow.processing.last.running": "Running since {{when}}",
  "datox.v2.workflow.processing.last.waiting": "Waiting for files since {{when}}",
  "datox.v2.workflow.processing.last.other": "Last run started {{when}}",
  "datox.v2.workflow.processing.refreshed.one": "refreshed this report",
  "datox.v2.workflow.processing.refreshed.other": "refreshed {{count}} client reports",
  "datox.v2.workflow.took.one": "took 1 min",
  "datox.v2.workflow.took.other": "took {{count}} min",
  "datox.v2.workflow.took.underMinute": "took under a minute",
  "datox.v2.workflow.duration.one": "1 min",
  "datox.v2.workflow.duration.other": "{{count}} min",
  "datox.v2.workflow.duration.underMinute": "Under a minute",
  "datox.v2.workflow.runs.result": "Result",
  "datox.v2.workflow.runs.duration": "Duration",
  "datox.v2.workflow.runs.all": "All runs",
  "datox.v2.workflow.client.lead.one": "1 table filled for {{client}}",
  "datox.v2.workflow.client.lead.other": "{{count}} tables filled for {{client}}",
  "datox.v2.workflow.client.empty": "No tables for {{client}} in the last run.",
  "datox.v2.workflow.review.reviewers": "Reviewers",
  "datox.v2.workflow.review.noReviewers": "No reviewers yet.",
  "datox.v2.workflow.review.reviewer": "Reviewer",
  "datox.v2.workflow.review.state": "State",
  "datox.v2.workflow.review.updated": "Updated",
  "datox.v2.workflow.reviewer.approved": "Approved",
  "datox.v2.workflow.reviewer.rejected": "Changes requested",
  "datox.v2.workflow.reviewer.viewed": "Viewed",
  "datox.v2.workflow.reviewer.pending": "Waiting",
  "datox.v2.workflow.action.uploadNew": "Upload new files",
  "datox.v2.workflow.files.tables.one": "1 table read from these files",
  "datox.v2.workflow.files.tables.other": "{{count}} tables read from these files",
  "datox.v2.workflow.files.tablesNone": "No tables read from these files yet",
  "datox.v2.workflow.update.waiting": "After the files are in",
  "datox.v2.workflow.update.running": "Updating now",
  "datox.v2.workflow.update.setup": "Needs a setting first",
  "datox.v2.workflow.update.failed": "The last update failed",
  "datox.v2.workflow.update.never": "Not updated yet",
  "datox.v2.workflow.update.newFiles": "New files since the last update",
  "datox.v2.workflow.update.noClient": "No data for this client",
  "datox.v2.workflow.update.done": "Updated {{date}}",
  "datox.v2.workflow.update.last": "Last updated {{when}}",
  "datox.v2.workflow.update.none": "Not updated yet. Once the files are in, run the update.",
  // workflow (UX research)
  "datox.v2.workflow.card.filesError": "The files couldn't be loaded.",
  "datox.v2.workflow.card.processing.one": "{{count}} file is still being processed…",
  "datox.v2.workflow.card.processing.other": "{{count}} files are still being processed…",
  "datox.v2.workflow.card.run.first": "Not updated yet. Update the report to fill it.",
  "datox.v2.workflow.card.run.files": "New files since {{date}}. Update the report.",
  "datox.v2.workflow.card.run.filesNoDate": "New files since the last update. Update the report.",
  "datox.v2.workflow.card.run.settings": "Settings changed since the last update. Update the report.",
  "datox.v2.workflow.card.failedAt": "The update on {{when}} failed.",
  "datox.v2.workflow.card.failed.reason": "Reason: {{reason}}.",
  "datox.v2.workflow.card.failed.still": "The report still shows {{date}} data.",
  "datox.v2.workflow.card.setup": "This report isn't fully set up yet ({{what}}).",
  "datox.v2.workflow.card.setup.tables": "tables",
  "datox.v2.workflow.card.setup.clients": "clients",
  "datox.v2.workflow.card.setup.period": "reporting period",
  "datox.v2.workflow.card.setup.date": "as-of date",
  "datox.v2.workflow.card.setup.ask": "Ask your analyst to finish it.",
  "datox.v2.workflow.card.running.elapsed": "{{time}} so far",
  "datox.v2.workflow.card.running.usual.one": "usually about 1 min",
  "datox.v2.workflow.card.running.usual.other": "usually about {{count}} min",
  "datox.v2.workflow.card.running.leave": "you can leave this page",
  "datox.v2.workflow.card.waitingReviewSent": "Waiting for review from {{names}} · sent {{date}}.",
  "datox.v2.workflow.card.changesBy": "{{name}} asked for changes: “{{note}}”",
  "datox.v2.workflow.card.action.reload": "Try again",
  "datox.v2.workflow.update.settingsChanged": "Settings changed since the last update",
  "datox.v2.workflow.update.dataTo": "Data to {{date}}",
  "datox.v2.workflow.update.lastLower": "last updated {{when}}",
  "datox.v2.workflow.runs.none": "No updates yet.",
  "datox.v2.workflow.runs.recentCount": "Recent runs ({{count}})",
  "datox.v2.workflow.runs.started": "Started",
  "datox.v2.workflow.files.previous": "previous",
  "datox.v2.workflow.files.previousNote.one": "1 older file is kept from an earlier upload. The newest file of each kind is the current one.",
  "datox.v2.workflow.files.previousNote.other": "{{count}} older files are kept from earlier uploads. The newest file of each kind is the current one.",
  "datox.v2.workflow.files.previewFile": "Preview {{name}}",
  "datox.v2.workflow.pipeline": "Pipeline",
  "datox.v2.workflow.pipeline.files": "Files",
  "datox.v2.workflow.pipeline.tables": "Tables",
  "datox.v2.workflow.pipeline.extraction": "Extraction",
  "datox.v2.workflow.pipeline.calculation": "Calculation",
  "datox.v2.workflow.pipeline.output": "Output",
  "datox.v2.workflow.review.note": "Note",
  "datox.v2.workflow.technical.tabs": "For analysts. Files, Categories (the tables), Extractions (what was read), Transformations (the calculations), Output (this client's tables) and Approval.",
  "datox.v2.workflow.technical.emptyHint": "Update the report to fill this.",
  "datox.v2.workflow.edit.start": "Edit pipeline",
  "datox.v2.workflow.edit.done": "Done editing",
  "datox.v2.workflow.edit.note.one": "Editing. Changes here affect this report.",
  "datox.v2.workflow.edit.note.other": "Editing. Changes here affect all {{count}} client reports.",
  "datox.v2.workflow.edit.deleteNote.one": "Used by 1 client report. Delete it?",
  "datox.v2.workflow.edit.deleteNote.other": "Used by {{count}} client reports. Delete it?",
  "datox.v2.workflow.edit.deleteConfirm": "Delete file",
  "datox.v2.workflow.integration.description": "Pull this period's files ({{period}}) from your integration. Then update the report.",
  "datox.v2.workflow.preview.reading": "Reading the sheet… The page may pause for a moment.",
  "datox.v2.workflow.preview.readingHere": "Reading in the background took too long, so the sheet is being read here. The page may not respond until it is done.",
  "datox.v2.workflow.preview.downloading": "Downloading {{loaded}} of {{total}} MB…",
  "datox.v2.workflow.preview.limitOf": "Showing the first {{count}} of {{total}} rows",
  "datox.v2.grid.summary": "{{label}}: {{rows}}, {{columns}}",
  "datox.v2.grid.keys": "Arrow keys move, Command C copies.",
  "datox.v2.grid.cell": "Row {{row}}, {{column}}: {{value}}",
  "datox.v2.grid.empty": "empty",
  "datox.v2.grid.openTable": "Open as table",
  "datox.v2.grid.backToGrid": "Back to grid",
  "datox.v2.grid.csv": "CSV",
  "datox.v2.grid.copy": "Copy",
  "datox.v2.grid.copyCell": "Copy cell value",
  "datox.v2.grid.copied": "Copied",
  "datox.v2.grid.previous": "Previous",
  "datox.v2.grid.next": "Next",
  "datox.v2.grid.range": "{{start}}–{{end}} of {{total}}",
  "datox.v2.workflow.preview.large": "Large file ({{size}}).",
  "datox.v2.workflow.preview.largeHint.one": "The preview takes about 1 minute. Download it instead?",
  "datox.v2.workflow.preview.largeHint.other": "The preview takes about {{count}} minutes. Download it instead?",
  "datox.v2.workflow.preview.downloadInstead": "Download",
  "datox.v2.workflow.preview.anyway": "Preview anyway",
  "datox.v2.review.heading": "Report review",
  "datox.v2.review.intro": "Send {{name}}'s report to a colleague. They'll get a link and can approve it or ask for changes.",
  "datox.v2.review.reload": "Refresh",
  "datox.v2.review.option": "{{name}} · current report",
  "datox.v2.review.picker": "Report",
  "datox.v2.review.view": "View report",
  "datox.v2.review.ready": "Report ready",
  "datox.v2.review.decision": "Reviewer's decision",
  "datox.v2.review.scoped": "For this report",
  "datox.v2.review.noReviewersHint": "No one has been asked yet.",
  "datox.v2.review.requestTitle": "Request review",
  "datox.v2.review.sentAt": "Sent {{date}}",
  "datox.v2.review.emptyTitle": "Nothing to review yet",
  "datox.v2.review.emptyHint": "Save the report first, then ask a colleague to review it.",
  "datox.v2.review.back": "Back to the report",
  "datox.v2.title.editor": "{{client}} · {{report}} — Lesha Bank",
  "datox.v2.title.report": "{{report}} — Lesha Bank",
  "datox.v2.title.reports": "Reports — Lesha Bank",
  // reports (UX research)
  "datox.v2.title.app": "Lesha Bank",
  // The account menu's design switch (datox/v2/design-flag.ts); the same words in his classic menu.
  "datox.v2.design.toggle": "New design",
  // The account menu's Dark theme switch (datox/v2/theme-switch.ts): the base app's colour scheme, as Compliance V2 words it.
  "datox.v2.theme.dark": "Dark theme",
  "datox.v2.title.page": "{{page}} — Lesha Bank",
  "datox.v2.login.title": "Sign in to Lesha Bank",
  "datox.v2.login.description": "Sign in with your company Microsoft account to continue to Lesha Bank.",
  "datox.v2.reports.dataTo": "Data to {{date}}",
  "datox.v2.reports.older": "Older data",
  "datox.v2.reports.noDataDate": "No data date",
  "datox.v2.reports.olderHint": "This client has another report with newer data. Check that one first.",
  "datox.v2.reports.sendWhy.noData": "This report has no data yet. Add the client's files in Workflow first.",
  "datox.v2.reports.sendWhy.running": "The report is updating. Send it when the update has finished.",
  // §74j: the last run failed.
  "datox.v2.report.status.failed": "Update failed",
  "datox.v2.reports.sendWhy.failed": "The last update failed. See why in Workflow, then try again.",
  "datox.v2.reports.searchKeys": "Enter opens the first report, ↓ moves to the results",
  "datox.v2.tech.ov.overview": "Overview",
  "datox.v2.tech.ov.untitledPage": "Page {{index}}",
  "datox.v2.tech.ov.period.one": "Period · the only report",
  "datox.v2.tech.ov.period.other": "Period · all {{count}} reports",
  "datox.v2.tech.ov.widgets": "{{client}} · widgets",
  "datox.v2.tech.ov.widgetsAll": "This report · widgets",
  "datox.v2.tech.ov.noFiles": "No files yet",
  "datox.v2.tech.ov.loading": "Reading this report's data…",
  "datox.v2.tech.ov.dataEnds": "Data ends <b>{{end}}</b>",
  "datox.v2.tech.ov.cutoff": "period runs to <b>{{cutoff}}</b>",
  "datox.v2.tech.ov.gap.one": "1 day without data",
  "datox.v2.tech.ov.gap.other": "{{count}} days without data",
  "datox.v2.tech.ov.gapWarn": "More than a month without data: a month's files are likely missing.",
  "datox.v2.tech.ov.gapNote": "Less than a month without data.",
  "datox.v2.tech.ov.upload": "Upload this month's files",
  "datox.v2.tech.ov.uploadHint": "Opens Source files for this report set. Files uploaded there serve all its client reports.",
  "datox.v2.tech.ov.upToDate": "<b>Up to date</b> · data to {{end}}",
  "datox.v2.tech.ov.allRead": "All rows read",
  "datox.v2.tech.ov.notAllRead": "Some sheet rows were not read",
  "datox.v2.tech.ov.checksPassed": "this client's checks passed",
  "datox.v2.tech.ov.checksFailed.one": "1 of this client's checks failed: {{label}}",
  "datox.v2.tech.ov.checksFailed.other": "{{count}} of this client's checks failed, first: {{label}}",
  "datox.v2.tech.ov.noRun": "Not calculated yet",
  "datox.v2.tech.ov.rerun.one": "Re-run the report",
  "datox.v2.tech.ov.rerun.other": "Re-run for all {{count}}",
  "datox.v2.tech.ov.rerunHint.one": "Re-runs the calculation of this report with the current files.",
  "datox.v2.tech.ov.rerunHint.other": "Re-runs the calculation of all {{count}} client reports with the current files.",
  "datox.v2.tech.ov.failed": "<b>{{file}}</b> could not be read",
  "datox.v2.tech.ov.failedSub": "uploaded {{when}}. This report still shows the data read {{read}}.",
  "datox.v2.tech.ov.failedSubNoRead": "uploaded {{when}}. Nothing was read from it.",
  "datox.v2.tech.ov.processing": "<b>{{file}}</b> is still being read",
  "datox.v2.tech.ov.processingSub": "uploaded {{when}}. Its rows reach the report on the next update.",
  "datox.v2.tech.ov.openFile": "Open file",
  "datox.v2.tech.ov.uploadAgain": "Upload again",
  "datox.v2.tech.ov.new.one": "<b>1 new file uploaded {{when}}</b>",
  "datox.v2.tech.ov.new.other": "<b>{{count}} new files uploaded {{when}}</b>",
  "datox.v2.tech.ov.newSub": "not in the report yet",
  "datox.v2.tech.ov.update.one": "Update the report",
  "datox.v2.tech.ov.update.other": "Update the reports",
  "datox.v2.tech.ov.updateScope.one": "Re-runs this report",
  "datox.v2.tech.ov.updateScope.other": "Re-runs all {{count}} client reports",
  "datox.v2.tech.ov.files.one": "file",
  "datox.v2.tech.ov.files.other": "files",
  "datox.v2.tech.ov.filesOf": "{{ok}} of {{count}}",
  "datox.v2.tech.ov.tables.one": "table",
  "datox.v2.tech.ov.tables.other": "tables",
  "datox.v2.tech.ov.rows.one": "row",
  "datox.v2.tech.ov.rows.other": "rows",
  "datox.v2.tech.ov.clientRows.one": "row for this client",
  "datox.v2.tech.ov.clientRows.other": "rows for this client",
  "datox.v2.tech.ov.reportTables.one": "report table",
  "datox.v2.tech.ov.reportTables.other": "report tables",
  "datox.v2.tech.ov.widgetsOn": "widgets on {{pages}}",
  "datox.v2.tech.ov.pages.one": "1 page",
  "datox.v2.tech.ov.pages.other": "{{count}} pages",
  "datox.v2.tech.ov.uploaded": "Uploaded {{when}}",
  "datox.v2.tech.ov.uploadedLower": "uploaded {{when}}",
  "datox.v2.tech.ov.newUpload": "new upload {{when}}",
  "datox.v2.tech.ov.calculated": "Calculated {{when}}",
  "datox.v2.tech.ov.offPage.one": "1 table is on no page ({{names}})",
  "datox.v2.tech.ov.offPage.other": "{{count}} tables are on no page ({{names}})",
  "datox.v2.tech.ov.stale": "From the read of {{when}}",
  "datox.v2.tech.ov.sources": "Sources",
  "datox.v2.tech.ov.col.table": "Table",
  "datox.v2.tech.ov.col.rows": "Rows",
  "datox.v2.tech.ov.col.rowsAll": "Rows, all clients",
  "datox.v2.tech.ov.col.rowsClient": "Rows for {{client}}",
  "datox.v2.tech.ov.col.dataTo": "Data to",
  "datox.v2.tech.ov.col.used": "Used in this report",
  "datox.v2.tech.ov.col.usedTip": "Widgets in this report that read this table",
  "datox.v2.tech.ov.shared": "shared",
  "datox.v2.tech.ov.sharedHint": "This table has no client column: every client report reads all of it.",
  "datox.v2.tech.ov.fileMeta": "{{size}} · uploaded {{when}}",
  "datox.v2.tech.ov.new": "New",
  "datox.v2.tech.ov.failedTag": "Not read",
  "datox.v2.tech.ov.processingTag": "Reading",
  "datox.v2.tech.ov.open": "Open",
  "datox.v2.tech.ov.rowsAction": "Rows",
  "datox.v2.tech.ov.used.one": "1 widget",
  "datox.v2.tech.ov.used.other": "{{count}} widgets",
  "datox.v2.tech.ov.notUsed": "Not used",
  "datox.v2.tech.ov.usedHint": "Inferred: matched from the report tables' values and column names, the backend stores no such link yet.",
  "datox.v2.tech.ov.headerRows": "The sheet has {{sheet}} rows. Rows 1–{{header}} are its title, headers and blank lines; data rows {{first}}–{{last}} were all read, so nothing is missing.",
  "datox.v2.tech.ov.headerRowsUnknown": "Rows 1–{{header}} of the sheet come before its data; data rows {{first}}–{{last}} were read.",
  "datox.v2.tech.ov.headerRowsPart": "Data rows {{first}}–{{last}} were read; the sheet has {{sheet}} rows.",
  "datox.v2.tech.ov.emptyTitle": "No files for this period yet",
  "datox.v2.tech.ov.emptyBody.one": "This report has nothing to show until files are uploaded.",
  "datox.v2.tech.ov.emptyBody.other": "The {{count}} client reports in this period have nothing to show until files are uploaded. One upload serves all of them.",
  "datox.v2.tech.ov.emptyUpload": "Upload files",
  "datox.v2.tech.ov.emptyHint": "Opens Edit pipeline.",
  "datox.v2.tech.ov.emptyAnalyst": "An analyst uploads them with Edit pipeline.",
  "datox.v2.tech.lin.dataTo": "Data to {{day}}",
  "datox.v2.tech.lin.asOfLower": "as of {{day}}",
  "datox.v2.tech.lin.calculatedLower": "calculated {{when}}",
  "datox.v2.tech.lin.inferredNote": "formula not stored, columns matched by name",
  "datox.v2.tech.lin.checkedLower": "checked against the rows",
  "datox.v2.tech.lin.alsoFeeds.one": "{{table}} also feeds 1 other widget",
  "datox.v2.tech.lin.alsoFeeds.other": "{{table}} also feeds {{count}} other widgets",
  "datox.v2.tech.lin.followSelect": "Follows the widget you select on the page",
  "datox.v2.tech.lin.followExplain": "From the widget's “Where does this come from?”",
  "datox.v2.tech.lin.dashedHint": "The backend does not store these links yet: the step and the source columns are matched here from column names, values and the calculation's step text.",
  "datox.v2.tech.lin.widget": "Widget",
  "datox.v2.tech.lin.reportTable": "Report table",
  "datox.v2.tech.lin.calculation": "Calculation",
  "datox.v2.tech.lin.sourceTable": "Source table",
  "datox.v2.tech.lin.file": "File",
  "datox.v2.tech.lin.kind.kpi": "KPI",
  "datox.v2.tech.lin.kind.table": "Table",
  "datox.v2.tech.lin.kind.chart": "Chart",
  "datox.v2.tech.lin.shows": "shows",
  "datox.v2.tech.lin.thisClient": "This client",
  "datox.v2.tech.lin.all.one": "This report",
  "datox.v2.tech.lin.all.other": "All {{count}} reports",
  "datox.v2.tech.lin.tableRows.one": "1 row for this client",
  "datox.v2.tech.lin.tableRows.other": "{{n}} rows for this client",
  "datox.v2.tech.lin.checkPassed": "this client's check passed",
  "datox.v2.tech.lin.checkFailed": "this client's check failed",
  "datox.v2.tech.lin.sameStep": "Same step for each client",
  "datox.v2.tech.lin.step": "Step {{n}} · {{label}}",
  "datox.v2.tech.lin.openStep": "Open step",
  "datox.v2.tech.lin.openFile": "Open file",
  "datox.v2.tech.lin.notTraced": "Not traced yet",
  "datox.v2.tech.lin.noStep": "No step of the calculation names these columns.",
  "datox.v2.tech.lin.noSource": "No source table matches this report table's values or column names.",
  "datox.v2.tech.lin.noTable": "This widget reads no report table of this client.",
  "datox.v2.tech.lin.used.one": "1 row used on {{day}}",
  "datox.v2.tech.lin.used.other": "{{n}} rows used on {{day}}",
  "datox.v2.tech.lin.usedAll.one": "1 row used",
  "datox.v2.tech.lin.usedAll.other": "{{n}} rows used",
  "datox.v2.tech.lin.kept": "{{kept}} kept",
  "datox.v2.tech.lin.clientRange.one": "1 row for this client, {{from}} – {{to}}",
  "datox.v2.tech.lin.clientRange.other": "{{n}} rows for this client, {{from}} – {{to}}",
  "datox.v2.tech.lin.range": "{{from}} – {{to}}",
  "datox.v2.tech.lin.allRows.one": "1 row, all read",
  "datox.v2.tech.lin.allRows.other": "{{n}} rows, all read",
  "datox.v2.tech.lin.allRowsPart.one": "1 row",
  "datox.v2.tech.lin.allRowsPart.other": "{{n}} rows",
  "datox.v2.tech.lin.sheetRows": "sheet rows {{first}}–{{last}}",
  "datox.v2.tech.lin.headerRow": "row 1 is the header",
  "datox.v2.tech.lin.headerRowsN": "rows 1–{{n}} are its title and headers",
  "datox.v2.tech.lin.checkedHint": "Recomputed here from the source rows: the result equals the value in the report table.",
  "datox.v2.tech.lin.answer.sum": "Sum of <code>{{column}}</code> over {{client}}'s {{n}} rows{{on}} in {{table}}, read from <b>{{file}}</b>{{uploaded}}.",
  "datox.v2.tech.lin.answer.count": "The number of {{client}}'s rows{{on}} in {{table}} ({{n}}), read from <b>{{file}}</b>{{uploaded}}.",
  "datox.v2.tech.lin.answer.share": "Each row's share of the total <code>{{column}}</code> of {{client}}'s {{n}} rows{{on}} in {{table}}, matched by <code>{{key}}</code>; {{kept}}. Read from <b>{{file}}</b>{{uploaded}}.",
  "datox.v2.tech.lin.answer.largest": "the {{kept}} largest are kept",
  "datox.v2.tech.lin.answer.keptSome": "{{kept}} of them are shown",
  "datox.v2.tech.lin.answer.values": "<code>{{column}}</code> holds the same values as <code>{{source}}</code> in {{table}}, read from <b>{{file}}</b>{{uploaded}}.",
  "datox.v2.tech.lin.answer.names": "<code>{{column}}</code> is linked by its name to <code>{{source}}</code> in {{table}}, read from <b>{{file}}</b>{{uploaded}}. The exact formula is not stored.",
  "datox.v2.tech.lin.answer.calculated": "<code>{{column}}</code> is calculated from {{table}}, read from <b>{{file}}</b>{{uploaded}}. The formula is not stored, so its source columns are not traced yet.",
  "datox.v2.tech.lin.answer.none": "Not traced yet: no source table matches the values or column names of {{table}}.",
  "datox.v2.tech.lin.answer.noTable": "Not traced yet: this widget reads no report table of this client.",
  "datox.v2.tech.lin.dated": " dated <b>{{day}}</b>",
  "datox.v2.tech.lin.uploadedShort": " (uploaded {{when}})",
  "datox.v2.tech.lin.where": "Where does this come from?",
  "datox.v2.tech.lin.unconnected": "not connected to data on the page",
  "datox.v2.tech.lin.answer.unconnected": "Not connected to data on the page yet: the widget names {{table}}, but has no dataset, so the page shows no value. Below is where {{table}} comes from.",
  "datox.v2.tech.ov.unconnected.one": "1 widget is not connected to data",
  "datox.v2.tech.ov.unconnected.other": "{{count}} widgets are not connected to data",
  "datox.v2.tech.lin.client": "this client",
  // Source files (V2 rail page /files; mock 62-source-files-mock v3).
  "datox.v2.files.title": "Source files",
  "datox.v2.files.loading": "Loading…",
  "datox.v2.files.loadingPage": "Loading source files…",
  "datox.v2.files.loadingFiles": "Loading files…",
  "datox.v2.files.error": "Source files could not be loaded.",
  "datox.v2.files.setError": "This report set's files could not be loaded.",
  "datox.v2.files.retry": "Try again",
  "datox.v2.files.empty": "No report sets yet. A report's source files show here once it has a period.",
  "datox.v2.files.feeds.one": "Feeds {{count}} client report",
  "datox.v2.files.feeds.other": "Feeds {{count}} client reports",
  "datox.v2.files.head.dataTo": "Data to {{date}}",
  "datox.v2.files.head.reports.one": "1 client report",
  "datox.v2.files.head.reports.other": "{{count}} client reports",
  "datox.v2.files.head.reportsPicked.one": "1 client report, {{client}}'s",
  "datox.v2.files.head.reportsPicked.other": "{{count}} client reports, {{client}}'s among them",
  "datox.v2.files.daysWithout.one": "{{count}} day without data",
  "datox.v2.files.daysWithout.other": "{{count}} days without data",
  "datox.v2.files.earlier": "Earlier periods",
  "datox.v2.files.uploading.one": "Uploading {{count}} file…",
  "datox.v2.files.uploading.other": "Uploading {{count}} files…",
  "datox.v2.files.more": "More ways to add files",
  "datox.v2.files.integration": "From integration",
  "datox.v2.files.integrationHint": "Pull this month's files from {{name}}",
  "datox.v2.files.integrationBusy": "Pulling files from {{name}}…",
  "datox.v2.files.integrationNone": "No integration connected to this report set",
  "datox.v2.files.new": "New",
  "datox.v2.files.reading": "Reading…",
  "datox.v2.files.failed": "Could not be read",
  "datox.v2.files.none": "No files in this period yet",
  "datox.v2.files.waitingSub": "Waiting for this month's file · last: {{file}}",
  "datox.v2.files.waitingLast": "last: {{file}} · {{date}}",
  "datox.v2.files.waitingPick": "Choose this month's {{name}} file (last: {{file}} · {{date}})",
  "datox.v2.files.preview": "Preview {{name}}",
  "datox.v2.files.previewShort": "Preview",
  "datox.v2.files.actions": "More for {{name}}",
  "datox.v2.files.download": "Download",
  "datox.v2.files.downloadFailed": "The file could not be downloaded.",
  "datox.v2.files.delete": "Delete",
  "datox.v2.files.deleting": "Deleting…",
  "datox.v2.files.deleteTitle": "Delete file",
  "datox.v2.files.deleteConfirm": "Delete {{name}} from this period? The next report update will not read it.",
  "datox.v2.files.deleteFailed": "The file could not be deleted.",
  "datox.v2.files.uploadFailed": "Could not upload {{name}}.",
  "datox.v2.files.updateFailed": "The reports could not be updated. Try again, or open a report's Technical details.",
  "datox.v2.files.dismiss": "Dismiss",
  "datox.v2.files.strip.failed": "could not be read",
  "datox.v2.files.strip.stillShow": "reports still show data to {{date}}",
  "datox.v2.files.openFile": "Open file",
  "datox.v2.files.uploadAgain": "Upload again",
  "datox.v2.files.strip.duplicate": "is already here",
  "datox.v2.files.strip.sameNameSize": "(same name and size)",
  "datox.v2.files.uploadAnyway": "Upload anyway",
  "datox.v2.files.skip": "Skip",
  "datox.v2.files.strip.newFiles.one": "{{count}} new file",
  "datox.v2.files.strip.newFiles.other": "{{count}} new files",
  "datox.v2.files.strip.notInReports": "not in reports yet",
  "datox.v2.files.updateReports.one": "Update {{count}} report",
  "datox.v2.files.updateReports.other": "Update {{count}} reports",
  "datox.v2.files.updating": "Updating reports…",
  "datox.v2.files.drop": "Drop to upload to {{name}}",
  "datox.v2.files.all.link": "All files",
  "datox.v2.files.all.title": "All files",
  "datox.v2.files.all.search": "Search by file, report set or period",
  "datox.v2.files.all.noPeriod": "No period",
  "datox.v2.files.all.error": "The files could not be loaded.",
  "datox.v2.files.all.empty": "No files uploaded yet.",
  "datox.v2.files.all.noMatch": "No files match “{{query}}”.",
  "datox.v2.files.all.deleteConfirm": "Delete {{name}}? Report updates will no longer read it.",
  "datox.v2.files.all.linkHint": "Every file of every factsheet and period",
  "datox.v2.files.tree.clear": "Clear search",
  "datox.v2.files.tree.enterOpens": "<kbd>Enter</kbd> opens {{name}}",
  "datox.v2.files.tree.noMatch": "Nothing matches “{{query}}”.",
  "datox.v2.files.tree.files.one": "{{count}} file · {{period}}",
  "datox.v2.files.tree.files.other": "{{count}} files · {{period}}",
  "datox.v2.files.tree.waiting.one": "{{count}} file waiting · {{period}}",
  "datox.v2.files.tree.waiting.other": "{{count}} files waiting · {{period}}",
  "datox.v2.files.tree.none": "No files yet",
  "datox.v2.files.tree.failed": "Files could not be loaded",
  "datox.v2.files.period.label": "Period: {{period}}",
  "datox.v2.files.period.menu": "Period",
  "datox.v2.files.period.latestHint": "Latest · new files go here",
  "datox.v2.files.period.readOnly": "Read only",
  "datox.v2.files.period.files.one": "{{count}} file",
  "datox.v2.files.period.files.other": "{{count}} files",
  "datox.v2.files.period.earlier": "Earlier period, read only",
  "datox.v2.files.period.goesTo": "new files go to <link>{{period}}</link>",
  "datox.v2.files.period.goLatest": "Go to the latest period, {{period}}",
  "datox.v2.files.periodError": "This period's files could not be loaded.",
  "datox.v2.files.client.older": "Older data",
  "datox.v2.files.client.olderHint": "This client has another report with newer data. Check that one first.",
  "datox.v2.files.client.open": "Open report",
  "datox.v2.files.client.openHint": "Open {{client}}'s report in {{report}}",
  "datox.v2.files.client.showRows": "Show rows",
  "datox.v2.files.client.showRowsLabel": "Show {{client}}'s rows in {{table}}",
  "datox.v2.files.rows.title": "{{table}} · {{client}}'s rows",
  "datox.v2.files.rows.from": "From {{file}}, uploaded {{date}}",
  "datox.v2.files.rows.where": "rows where {{column}} is {{value}}",
  "datox.v2.files.rows.tables": "Tables",
  "datox.v2.files.rows.original": "Original file",
  "datox.v2.files.rows.close": "Close",
  "datox.v2.files.rows.csv": "Download CSV",
  "datox.v2.files.rows.loading": "Loading the rows read from this period's files…",
  "datox.v2.files.rows.failed": "The rows could not be loaded.",
  "datox.v2.files.rows.none": "This file's rows were not found in this period's read data.",
  "datox.v2.files.rows.same": "{{table}} is the same for every client: it has no client column.",
  "datox.v2.files.rows.originalTip": "Every client's rows, as uploaded ({{size}})",
  "datox.v2.files.rows.originalSlow.one": "Every client's rows, as uploaded ({{size}}, about 1 minute to open)",
  "datox.v2.files.rows.originalSlow.other": "Every client's rows, as uploaded ({{size}}, about {{count}} minutes to open)",
  "datox.v2.files.col.level1": "Clients, level 1 of 2",
  "datox.v2.files.col.search": "Client or code",
  "datox.v2.files.col.searchLabel": "Search clients by name or code",
  "datox.v2.files.col.clients": "Clients",
  "datox.v2.files.col.all": "All clients",
  "datox.v2.files.col.level2": "Reports for {{scope}}, level 2 of 2",
  "datox.v2.files.col.back": "Back to clients",
  "datox.v2.files.col.noClients": "No clients yet",
  "datox.v2.files.col.olderTo": "Older data to {{date}}",
  "datox.v2.files.col.allHint": "Every factsheet, for all its clients",
  "datox.v2.files.col.noneHint": "Factsheets with no clients yet",
  "datox.v2.files.pick.client.one": "Pick {{client}}'s report to see its files and where uploads go.",
  "datox.v2.files.pick.client.other": "{{client}} has {{count}} reports. Pick one to see its files and where uploads go.",
  "datox.v2.files.pick.none.one": "Pick the report to see its files and where uploads go.",
  "datox.v2.files.pick.none.other": "{{count}} factsheets have no clients yet. Pick one to see its files and where uploads go.",
  "datox.v2.files.target.all.one": "Uploads go to {{report}} · {{period}} and feed its one client report.",
  "datox.v2.files.target.all.other": "Uploads go to {{report}} · {{period}} and feed all {{count}} client reports.",
  "datox.v2.files.target.client.one": "Uploads go to {{report}} · {{period}} and feed its one client report, {{client}}'s.",
  "datox.v2.files.target.client.other": "Uploads go to {{report}} · {{period}} and feed all {{count}} client reports, {{client}}'s included.",
  "datox.v2.files.target.none": "Uploads go to {{report}} · {{period}}. This factsheet has no clients yet.",
  "datox.v2.files.zone.title": "Drop files here or <link>browse</link>",
  "datox.v2.chats.history": "Chat history",
  "datox.v2.chats.new": "New chat",
  "datox.v2.chats.search": "Search chats",
  "datox.v2.chats.group.today": "Today",
  "datox.v2.chats.group.yesterday": "Yesterday",
  "datox.v2.chats.group.week": "Previous 7 days",
  "datox.v2.chats.group.older": "Older",
  "datox.v2.chats.kind.general": "General question",
  "datox.v2.chats.all": "All clients",
  "datox.v2.chats.noReport": "No report",
  "datox.v2.chats.noMessages": "No messages",
  "datox.v2.chats.row.report": "{{report}} · period {{period}}",
  "datox.v2.chats.row.all": "All clients · period {{period}}",
  "datox.v2.chats.row.workflow": "Workflow run · period {{period}}",
  "datox.v2.chats.tip.client": "{{client}} in {{report}}, reporting period {{period}}",
  "datox.v2.chats.tip.all": "All clients in {{report}}, reporting period {{period}}",
  "datox.v2.chats.tip.workflow": "Workflow run of {{report}}, reporting period {{period}}",
  "datox.v2.chats.tip.general": "General question, not about a report",
  "datox.v2.chats.bar": "This chat is about",
  "datox.v2.chats.fact.client": "Client",
  "datox.v2.chats.fact.report": "Report",
  "datox.v2.chats.fact.period": "Reporting period",
  "datox.v2.chats.fact.workflow": "Workflow run",
  "datox.v2.chats.more": "More for {{name}}",
  "datox.v2.chats.actions": "Chat actions",
  "datox.v2.chats.delete": "Delete chat",
  "datox.v2.chats.deleteTitle": "Delete chat",
  "datox.v2.chats.deleteConfirm": "Delete the chat “{{name}}”? Its messages will be gone.",
  "datox.v2.chats.deleteAction": "Delete",
  "datox.v2.chats.deleting": "Deleting…",
  "datox.v2.chats.deleteFailed": "The chat could not be deleted.",
  "datox.v2.chats.loading": "Loading chats…",
  "datox.v2.chats.error": "Chats could not be loaded.",
  "datox.v2.chats.retry": "Try again",
  "datox.v2.chats.noMatch": "No chats match “{{query}}”.",
  "datox.v2.chats.none": "No chats yet",
  "datox.v2.chats.back": "Back to chats",
  "datox.v2.chats.openReport": "Open report",
  "datox.v2.chats.openReportClient": "Open {{client}}'s report in {{report}}",
  "datox.v2.chats.openReportAll": "Open {{report}}",
  "datox.v2.chats.noFiles.title": "No files in this period yet",
  "datox.v2.chats.noFiles.hint": "The assistant has nothing to read until this month's files are uploaded.",
  "datox.v2.chats.noFiles.upload": "Upload this month's files",
  "datox.v2.chats.prefill": "<b>Not sent yet.</b> Press <kbd>Enter</kbd> or the arrow to send.",
  "datox.v2.chats.opening": "Opening the chat…",
  "datox.v2.chats.openError": "The chat could not be opened.",
  "datox.v2.chats.notFound": "This chat was not found. It may have been deleted.",
  "datox.v2.chats.waiting": "The workflow has not started this chat yet.",
  "datox.v2.chats.landing.titleGeneral": "Ask a question",
  "datox.v2.chats.landing.titleClient": "Ask about {{client}}'s report",
  "datox.v2.chats.landing.titleReport": "Ask about {{report}}",
  "datox.v2.chats.landing.placeholder": "Ask about a number, a missing value, or a line to send",
  "datox.v2.chats.landing.message": "Message",
  "datox.v2.chats.landing.start": "Start chat",
  "datox.v2.chats.landing.starting": "Starting the chat…",
  "datox.v2.chats.landing.error": "The chat could not be started. Try again.",
  "datox.v2.chats.scope.about": "Chat about",
  "datox.v2.chats.scope.search": "Find a client or report",
  "datox.v2.chats.scope.period": "Reporting period {{period}}",
  "datox.v2.chats.scope.noFiles": "No files yet",
  "datox.v2.chats.scope.clients.one": "{{count}} client",
  "datox.v2.chats.scope.clients.other": "{{count}} clients",
  "datox.v2.chats.scope.noMatch": "No clients or reports match.",
  "datox.v2.chats.suggest.return": "Explain this month's return",
  "datox.v2.chats.suggest.na": "Why is a value N/A?",
  "datox.v2.chats.suggest.line": "Write a line for the client",
  // Workflows (V2 rail page /catalog/workflows; mock 71 __mock-workflows, variant A; then Source files' two columns, the
  // client then its reports, datox.v2.files.col.*).
  "datox.v2.workflows.loading": "Loading workflows…",
  "datox.v2.workflows.error": "Workflows could not be loaded.",
  "datox.v2.workflows.pick.client.one": "Pick {{client}}'s report to see its workflow.",
  "datox.v2.workflows.pick.client.other": "{{client}} has {{count}} reports. Pick one to see its workflow.",
  "datox.v2.workflows.pick.none.one": "Pick the report to see its workflow.",
  "datox.v2.workflows.pick.none.other": "{{count}} factsheets have no clients yet. Pick one to see its workflow.",
  "datox.v2.workflows.line.loading": "Checking files…",
  "datox.v2.workflows.line.failed": "Its files could not be loaded",
  "datox.v2.workflows.line.updating.tables": "Updating, at Tables",
  "datox.v2.workflows.line.updating.figures": "Updating, at Figures",
  "datox.v2.workflows.line.updating.reports": "Updating, at Client reports",
  "datox.v2.workflows.line.updating.any": "Updating",
  "datox.v2.workflows.line.waiting": "Update waiting for files",
  "datox.v2.workflows.line.stopped": "Update stopped on {{date}}",
  "datox.v2.workflows.line.unreadable.one": "1 file could not be read",
  "datox.v2.workflows.line.unreadable.other": "{{count}} files could not be read",
  "datox.v2.workflows.line.reading.one": "Reading 1 file",
  "datox.v2.workflows.line.reading.other": "Reading {{count}} files",
  "datox.v2.workflows.line.noFiles": "No files yet",
  "datox.v2.workflows.line.new.one": "1 new file not in the reports",
  "datox.v2.workflows.line.new.other": "{{count}} new files not in the reports",
  "datox.v2.workflows.line.never": "Not updated yet",
  "datox.v2.workflows.line.upToDate": "Up to date since {{date}}",
  "datox.v2.workflows.head.reports.one": "1 client report",
  "datox.v2.workflows.head.reports.other": "{{count}} client reports",
  "datox.v2.workflows.head.reportsPicked.one": "1 client report, {{client}}'s",
  "datox.v2.workflows.head.reportsPicked.other": "{{count}} client reports, {{client}}'s among them",
  "datox.v2.workflows.head.noClients": "No clients yet. Set them in the report's settings.",
  "datox.v2.workflows.head.dataTo": "Data to {{date}}",
  "datox.v2.workflows.head.period": "Period {{period}}",
  "datox.v2.workflows.now.loading": "Checking this period's files…",
  "datox.v2.workflows.now.failed": "This factsheet's files could not be loaded.",
  "datox.v2.workflows.now.noFiles.title": "No files yet.",
  "datox.v2.workflows.now.noFiles.sub": "Add this period's exports in Source files, then update the report.",
  "datox.v2.workflows.now.addFiles": "Add files",
  "datox.v2.workflows.now.new.title.one": "1 new file is not in the reports yet.",
  "datox.v2.workflows.now.new.title.other": "{{count}} new files are not in the reports yet.",
  "datox.v2.workflows.now.new.sub": "{{name}}, added {{date}}",
  "datox.v2.workflows.now.new.subMany.one": "{{name}} and 1 more, the latest added {{date}}",
  "datox.v2.workflows.now.new.subMany.other": "{{name}} and {{count}} more, the latest added {{date}}",
  "datox.v2.workflows.now.never.title": "These files are not in the reports yet.",
  "datox.v2.workflows.now.never.sub.one": "1 file in this period. The client reports have not been updated with it.",
  "datox.v2.workflows.now.never.sub.other": "{{count}} files in this period. The client reports have not been updated with them.",
  "datox.v2.workflows.now.updateHint.one": "Reads the current files and refreshes the client report.",
  "datox.v2.workflows.now.updateHint.other": "Reads the current files and refreshes all {{count}} client reports.",
  "datox.v2.workflows.now.starting": "Starting the update…",
  "datox.v2.workflows.now.updateFailed": "The update could not be started. Try again.",
  "datox.v2.workflows.now.readOnly": "Ask an editor of this project to update the reports.",
  "datox.v2.workflows.now.updating.title.one": "Updating the client report.",
  "datox.v2.workflows.now.updating.title.other": "Updating the {{count}} client reports.",
  "datox.v2.workflows.now.updating.sub": "Started {{time}}, {{elapsed}} so far, usually about {{usual}}. You can leave this page.",
  "datox.v2.workflows.now.updating.subNoUsual": "Started {{time}}, {{elapsed}} so far. You can leave this page.",
  "datox.v2.workflows.now.progress": "See progress",
  "datox.v2.workflows.now.waiting.title": "The update is waiting for files.",
  "datox.v2.workflows.now.waiting.sub": "It goes on once this period's files are in Source files.",
  "datox.v2.workflows.now.stopped.title": "The update stopped.",
  "datox.v2.workflows.now.seeWhat": "See what happened",
  "datox.v2.workflows.now.tryAgain": "Try again",
  "datox.v2.workflows.now.trying": "Trying again…",
  "datox.v2.workflows.now.unreadable.title.one": "{{name}} could not be read.",
  "datox.v2.workflows.now.unreadable.title.other": "{{count}} files could not be read.",
  "datox.v2.workflows.now.unreadable.sub.one": "Upload it again in Source files.",
  "datox.v2.workflows.now.unreadable.sub.other": "Upload them again in Source files.",
  "datox.v2.workflows.now.openFiles": "Open Source files",
  "datox.v2.workflows.now.reading.title.one": "Reading 1 file.",
  "datox.v2.workflows.now.reading.title.other": "Reading {{count}} files.",
  "datox.v2.workflows.now.reading.sub": "The reports can be updated once the files are read.",
  "datox.v2.workflows.now.upToDate.title.one": "The client report is up to date.",
  "datox.v2.workflows.now.upToDate.title.other": "All client reports are up to date.",
  "datox.v2.workflows.now.upToDate.sub": "No files were added since the last update.",
  "datox.v2.workflows.now.openReports": "Open reports",
  "datox.v2.workflows.stepName.files": "Files",
  "datox.v2.workflows.stepName.tables": "Tables",
  "datox.v2.workflows.stepName.figures": "Figures",
  "datox.v2.workflows.stepName.reports": "Client reports",
  "datox.v2.workflows.track.label": "This update's steps",
  "datox.v2.workflows.track.files.count.one": "1 file",
  "datox.v2.workflows.track.files.count.other": "{{count}} files",
  "datox.v2.workflows.track.tables.count.one": "1 table",
  "datox.v2.workflows.track.tables.count.other": "{{count}} tables",
  "datox.v2.workflows.track.tables.now": "reading",
  "datox.v2.workflows.track.tables.empty.one": "1 empty",
  "datox.v2.workflows.track.tables.empty.other": "{{count}} empty",
  "datox.v2.workflows.track.tables.stopped": "stopped here",
  "datox.v2.workflows.track.figures.now": "calculating",
  "datox.v2.workflows.track.figures.stopped": "stopped here",
  "datox.v2.workflows.track.reports.now": "updating",
  "datox.v2.workflows.built.title": "In the client reports now",
  "datox.v2.workflows.built.by.latest": "Built by the <link>latest update</link>.",
  "datox.v2.workflows.built.by.rest": "Built by the <link>update of {{date}}</link>.",
  "datox.v2.workflows.built.by.updating": "Built by the <link>update of {{date}}</link>. They switch to the new update when it ends.",
  "datox.v2.workflows.built.by.stopped": "Built by the <link>update of {{date}}</link>. The update that stopped changed nothing here.",
  "datox.v2.workflows.built.none": "Nothing yet.",
  "datox.v2.workflows.built.never.one": "Nothing yet. The first update reads the files and builds the report. <link>See the files</link>",
  "datox.v2.workflows.built.never.other": "Nothing yet. The first update reads the files and builds the {{count}} reports. <link>See the files</link>",
  "datox.v2.workflows.built.pending": "Loading…",
  "datox.v2.workflows.built.open.files": "Open in Source files",
  "datox.v2.workflows.built.open.tables": "Open in the report's Workflow view",
  "datox.v2.workflows.built.open.figures": "Open in the report's Workflow view",
  "datox.v2.workflows.built.open.reports": "Open in Reports",
  "datox.v2.workflows.built.files.count.one": "1 file",
  "datox.v2.workflows.built.files.count.other": "{{count}} files",
  "datox.v2.workflows.built.tables.count.one": "1 table",
  "datox.v2.workflows.built.tables.count.other": "{{count}} tables",
  "datox.v2.workflows.built.tables.size": "From {{size}} of files",
  "datox.v2.workflows.built.tables.gone": "Not available",
  "datox.v2.workflows.built.figures.checks.one": "{{passed}} of 1 check passed",
  "datox.v2.workflows.built.figures.checks.other": "{{passed}} of {{n}} checks passed",
  "datox.v2.workflows.built.figures.noChecks": "No checks recorded",
  "datox.v2.workflows.built.figures.note.one": "1 note on {{client}}",
  "datox.v2.workflows.built.figures.note.other": "{{count}} notes on {{client}}",
  "datox.v2.workflows.built.figures.notes.one": "1 note",
  "datox.v2.workflows.built.figures.notes.other": "{{count}} notes",
  "datox.v2.workflows.built.figures.saved": "Saved {{date}}",
  "datox.v2.workflows.built.figures.gone": "Not available",
  "datox.v2.workflows.built.reports.clients.one": "1 client",
  "datox.v2.workflows.built.reports.clients.other": "{{count}} clients",
  "datox.v2.workflows.built.reports.older.one": "1 older copy",
  "datox.v2.workflows.built.reports.older.other": "{{count}} older copies",
  "datox.v2.workflows.built.reports.updated": "Updated {{date}}",
  "datox.v2.workflows.took.seconds": "{{seconds}} s",
  "datox.v2.workflows.took.minutes": "{{minutes}} min {{seconds}} s",
  "datox.v2.workflows.took.hours": "{{hours}} h {{minutes}} min",
  "datox.v2.workflows.updates.title": "Updates",
  "datox.v2.workflows.updates.none": "No updates yet. The first one starts when files are added and someone presses Update.",
  "datox.v2.workflows.updates.started": "Started",
  "datox.v2.workflows.updates.how": "How",
  "datox.v2.workflows.updates.result": "Result",
  "datox.v2.workflows.updates.took": "Took",
  "datox.v2.workflows.updates.soFar": "{{time}} so far",
  "datox.v2.workflows.updates.updated.one": "1 updated",
  "datox.v2.workflows.updates.updated.other": "{{count}} updated",
  "datox.v2.workflows.updates.open": "Open the update of {{date}}",
  "datox.v2.workflows.how.hand": "By hand",
  "datox.v2.workflows.how.auto": "Automatically",
  "datox.v2.workflows.result.done": "Completed",
  "datox.v2.workflows.result.running": "Updating",
  "datox.v2.workflows.result.stopping": "Stopping",
  "datox.v2.workflows.result.waiting": "Waiting for files",
  "datox.v2.workflows.result.stopped": "Stopped",
  "datox.v2.workflows.result.cancelled": "Cancelled",
  "datox.v2.workflows.result.other": "Unknown ({{status}})",
  "datox.v2.workflows.auto.label": "Automatic updates",
  "datox.v2.workflows.auto.state.off": "Automatic updates: Off",
  "datox.v2.workflows.auto.state.files": "Automatic updates: When new files arrive",
  "datox.v2.workflows.auto.state.schedule": "Automatic updates: On a schedule",
  "datox.v2.workflows.auto.state.scheduleNext": "Automatic updates: On a schedule, next on {{date}}",
  "datox.v2.workflows.auto.tip.off": "An update starts when someone presses Update. It can also start by itself when new files arrive, or on a schedule.",
  "datox.v2.workflows.auto.tip.files": "An update starts by itself when new files arrive.",
  "datox.v2.workflows.auto.tip.schedule": "An update starts by itself on a schedule.",
  "datox.v2.workflows.auto.setUp": "Set up",
  "datox.v2.workflows.auto.change": "Change",
  "datox.v2.workflows.run.back": "Back to {{name}}",
  "datox.v2.workflows.run.title": "Update of {{date}}",
  "datox.v2.workflows.run.took": "took {{took}}",
  "datox.v2.workflows.run.started": "started {{time}}",
  "datox.v2.workflows.run.refreshed.one": "1 client report refreshed",
  "datox.v2.workflows.run.refreshed.other": "{{count}} client reports refreshed",
  "datox.v2.workflows.run.stop": "Stop update",
  "datox.v2.workflows.run.stopping": "Stopping…",
  "datox.v2.workflows.run.actionFailed": "That did not go through. Try again.",
  "datox.v2.workflows.run.notFound": "This update could not be found.",
  "datox.v2.workflows.run.loading": "Loading the update…",
  "datox.v2.workflows.run.step.files.files.one": "1 file: {{names}}",
  "datox.v2.workflows.run.step.files.files.other": "{{count}} files: {{names}}",
  "datox.v2.workflows.run.step.files.none": "No files",
  "datox.v2.workflows.run.step.files.waiting": "Waiting for this period's files",
  "datox.v2.workflows.run.step.tables.read.one": "1 table: {{names}}",
  "datox.v2.workflows.run.step.tables.read.other": "{{count}} tables: {{names}}",
  "datox.v2.workflows.run.step.tables.readNoList": "Tables read",
  "datox.v2.workflows.run.step.tables.rows.one": "1 row, read {{date}}",
  "datox.v2.workflows.run.step.tables.rows.other": "{{n}} rows, read {{date}}",
  "datox.v2.workflows.run.step.tables.reading": "Reading the files",
  "datox.v2.workflows.run.step.tables.next": "Starts when the files are in",
  "datox.v2.workflows.run.step.tables.notReached": "Not reached",
  "datox.v2.workflows.run.step.tables.failed.one": "Stopped: {{names}} could not be read",
  "datox.v2.workflows.run.step.tables.failed.other": "Stopped: {{count}} tables could not be read ({{names}})",
  "datox.v2.workflows.run.step.tables.failedNoList": "Stopped: a table could not be read",
  "datox.v2.workflows.run.step.figures.saved": "Calculated and saved",
  "datox.v2.workflows.run.step.figures.calculating": "Calculating the figures",
  "datox.v2.workflows.run.step.figures.next": "Starts when the tables are read",
  "datox.v2.workflows.run.step.figures.notReached": "Not reached",
  "datox.v2.workflows.run.step.figures.failed": "Stopped: the figures could not be calculated",
  "datox.v2.workflows.run.step.reports.refreshed.one": "1 client report refreshed",
  "datox.v2.workflows.run.step.reports.refreshed.other": "{{count}} client reports refreshed",
  "datox.v2.workflows.run.step.reports.updating.one": "Updating 1 client report",
  "datox.v2.workflows.run.step.reports.updating.other": "Updating {{count}} client reports",
  "datox.v2.workflows.run.step.reports.waiting.one": "1 report to update",
  "datox.v2.workflows.run.step.reports.waiting.other": "{{count}} reports to update",
  "datox.v2.workflows.run.step.reports.waitingStill.one": "1 report, still showing the {{date}} data",
  "datox.v2.workflows.run.step.reports.waitingStill.other": "{{count}} reports, still showing the {{date}} data",
  "datox.v2.workflows.run.step.reports.notUpdated.one": "Not updated.",
  "datox.v2.workflows.run.step.reports.notUpdated.other": "Not updated.",
  "datox.v2.workflows.run.step.reports.notUpdatedStill.one": "Not updated. The report still shows the data from {{date}}.",
  "datox.v2.workflows.run.step.reports.notUpdatedStill.other": "Not updated. The {{count}} reports still show the data from {{date}}.",
  "datox.v2.workflows.run.said": "What the assistant said",
  "datox.v2.workflows.run.doing": "What the assistant is doing",
  "datox.v2.workflows.run.saidNone": "Nothing was recorded for this update.",
  "datox.v2.workflows.run.doingNone": "Working on the update.",
  "datox.v2.workflows.run.chat": "Open the chat",
  "datox.v2.workflows.run.answer": "Answer in the chat",
  "datox.v2.workflows.run.chatGone": "This update's chat is no longer available.",
  "datox.v2.workflows.run.replace": "Replace the file",
  "datox.v2.workflows.blank.title": "No workflows yet",
  "datox.v2.workflows.blank.body": "Each factsheet has a workflow that turns its source files into client reports. Create a factsheet in Reports and it shows here.",
  "datox.v2.workflows.blank.go": "Go to Reports",
} as const
